import React from 'react';
import './intro.css';
import bg from '../../assets/image.png';
import { Link } from 'react-scroll';
import btnImg from '../../assets/hireme.png';

const Intro = () => {
    return (
        <section id="intro">
            <div className="introContent">
                <span className='hello'>Hello, </span>
                <span className='introText'>I'm <span className="introName">Nick</span><br />Data Scientist</span>
                <p className="introPara">I am currently a student at Boston University</p>
                <Link to="skills" spy={true} smooth={true} offset={-50} duration={500}>
                    <button className="btn">
                        <img src={btnImg} alt="About me" className='btnImg' />About me
                    </button>
                </Link>
            </div>
            <img src={bg} alt="Profile" className="bg" />
        </section>
    );
}

export default Intro;
